/** @file Renames an attachment (ASCII name, unique among attachments). */
import { defineRename } from '../_shared/defineRename';
import { defineCommand } from '../defineCommand';

const renamer = defineRename({
  domain: 'attachment',
  kind: 'attachment',
  description: 'Rename an attachment (ASCII name, unique among attachments; -L/-R suffixes mark sides for mirrored directions); skin placeholders are separate names and stay.',
});

/** attachment.rename: skin and slot placeholders are separate names and stay; the current name is a no-op (R2-13). */
export const command = defineCommand({
  ...renamer,
  apply(draft, input, ctx) {
    const id = ctx.resolve('attachment', input.target);
    if (draft.attachments[id]?.name !== input.name) renamer.apply(draft, input, ctx);
  },
});
